import React from 'react';

const BusDetails = () => {
  return (
    <div className='container my-5'>
      <h1 className='text-center'>Here Show all Details info</h1>
    </div>
  );
};

export default BusDetails;  